import React from "react"

import PropTypes from "prop-types"
import Fade from "react-reveal/Fade"

import "./SofaTableChair.scss"

const SofaTableChair = ({ section }) => {
  return (
    <section className="furniture">
      <div className="furniture__wrapper">
        <Fade>
          <div className="furniture__wrapper__first">
            <p>{section.product1 || "Lorem Ipsum"}</p>
            <img
              src={
                section.image1?.url ||
                "https://images.unsplash.com/photo-1538688525198-9b88f6f53126?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8Nnx8ZnVybml0dXJlfGVufDB8fDB8fA%3D%3D&auto=format&fit=crop&w=500&q=60"
              }
              alt={section.image1?.alt}
            />
          </div>
          <div className="furniture__wrapper__second">
            <p>{section.product2 || "Lorem Ipsum"}</p>
            <img
              src={
                section.image2?.url ||
                "https://images.unsplash.com/photo-1554295405-abb8fd54f153?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8MTh8fGZ1cm5pdHVyZXxlbnwwfHwwfHw%3D&auto=format&fit=crop&w=500&q=60"
              }
              alt={section.image2?.alt}
            />
          </div>
          <div className="furniture__wrapper__third">
            <p>{section.product3 || "Lorem Ipsum"}</p>
            <img
              src={
                section.image3?.url ||
                "https://images.unsplash.com/photo-1616464917528-00525c081b89?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8MTd8fGZ1cm5pdHVyZXxlbnwwfHwwfHw%3D&auto=format&fit=crop&w=500&q=60"
              }
              alt={section.image3?.alt}
            />
          </div>
          <div className="furniture__wrapper__fourth">
            <p>{section.product4 || "Lorem Ipsum"}</p>
            <img
              src={
                section.image4?.url ||
                "https://images.unsplash.com/photo-1586023492125-27b2c045efd7?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8MTJ8fGZ1cm5pdHVyZXxlbnwwfHwwfHw%3D&auto=format&fit=crop&w=500&q=60"
              }
              alt={section.image4?.alt}
            />
          </div>
          <div className="furniture__wrapper__fifth">
            <p>{section.product5 || "Lorem Ipsum"}</p>
            <img
              src={
                section.image5?.url ||
                "https://images.unsplash.com/photo-1556228453-efd6c1ff04f6?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8MTF8fGZ1cm5pdHVyZXxlbnwwfHwwfHw%3D&auto=format&fit=crop&w=500&q=60"
              }
              alt={section.image5?.alt}
            />
          </div>
          <div className="furniture__wrapper__sixth">
            <p>{section.product6 || "Lorem Ipsum"}</p>
            <img
              src={
                section.image6?.url ||
                "https://images.unsplash.com/photo-1550226891-ef816aed4a98?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxzZWFyY2h8MTB8fGZ1cm5pdHVyZXxlbnwwfHwwfHw%3D&auto=format&fit=crop&w=500&q=60"
              }
              alt={section.image6?.alt}
            />
          </div>
        </Fade>
      </div>
    </section>
  )
}

SofaTableChair.propTypes = {
  section: PropTypes.object.isRequired,
}

export default SofaTableChair
